import './Header.css';

export function Header() {
  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <a href="https://www.bloomz.com" className="site-header__brand">
          <img src="/logo-bloomz-color.png" alt="Bloomz" className="site-header__logo" />
          <span className="site-header__title">Status</span>
        </a>
      </div>
    </header>
  );
}
